define([
    'notify/domain/entity/notification',
    'moment',
    'backbone'
], function(
    NotificationModel,
    Moment,
    Backbone
    ) {
    /**
     * @exports collections/notification-collection
     */
    var NotificationCollection = Backbone.Collection.extend({
        /**
         * Backbone.Collection を extend した NotificationCollection を定義する
         */
        model: NotificationModel,

        initialize: function(models, params) {
            this._type = params && params.type ? params.type : 'timeline';
            this._limit = params && params.limit ? params.limit : 100;
        },

        comparator: function(notification) {
            return - notification.getEventAt().unix();
        },

        /**
         * Collection内で保持している通知のうち、最新のイベント時刻を返す
         */
        latest: function() {
            return this.max(n => n.getEventAt());
        },

        /**
         * Collection内で保持している通知のうち、最古のイベント時刻を返す
         */
        oldest: function() {
            return this.min(n => n.getEventAt());
        }
    });

    return NotificationCollection;
});



// WEBPACK FOOTER //
// ./notify/domain/collection/notification.js